import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import About from './sections/About';
import Header from '../pages/sections/Header';
import PreviewMain from '../pages/sections/Preview/PreviewMain';
import Footer from '../pages/sections/Footer';
import Preview from '../pages/sections/Preview';
import { Container } from 'reactstrap'
import ErrorBoundary from './sections/ErrorBoundary';
import ItemsList from '../containers/ItemsList';
import Best from './sections/Best';
import { BESTSELLERS, OUR_COFFEE_LINK } from '../utils/constants';
import withCoffeeService from '../hoc/withCoffeeService';
import viewContext from '../contexts/viewContext';

class MainPage extends Component {
  onItemSelected = (itemId) => this.props.history.push(`/${OUR_COFFEE_LINK}/${itemId}`)

  render() {
    const { coffeeService } = this.props

    return (
      <>
        <Preview>
          <Container>
            <Header />
            <PreviewMain />
          </Container>
        </Preview>
        <About />

        <ErrorBoundary>
          <viewContext.Provider value={(<Best />)}>
            <ItemsList
              items={BESTSELLERS}
              getData={coffeeService.getItems.bind(null, BESTSELLERS)}
              onItemSelected={this.onItemSelected}
            />
          </viewContext.Provider>
        </ErrorBoundary>

        <Footer />
      </>
    )
  }
}

export default withCoffeeService()(withRouter(MainPage))

